import { Directive, DoCheck, ElementRef, Input, Optional } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';

@Directive({
    selector: '[externalLink]',
    standalone: true
})
export class ExternalLinkDirective implements DoCheck {
    @Input() externalLink: string;

    constructor(
        private el: ElementRef,
        @Optional() private link: RouterLinkWithHref
    ) { }

    ngDoCheck() {
        if (this.externalLink && this.el.nativeElement.href != this.externalLink) {
            this.el.nativeElement.href = this.externalLink;
        }
        if (this.link && this.externalLink != this.link.href) {
            this.bindHrefToRouter();
        }
    }

    private bindHrefToRouter() {
        if (!this.externalLink) {
            return;
        }

        if (this.link) {
            this.link.href = this.externalLink;
            this.link.onClick = () => true;
        }
    }
}
